<template>

	<section class="row">
		<div class="left_window column">
			<!-- Шапка -->
			<sm-phone-header></sm-phone-header>

			<!-- Поиск -->
			<div class="main_search_wrap">
				<input class="main_search" placeholder="Поиск" type="search" v-model="searchWord" @input="search(searchWord)">
			</div>

			<!-- Верхние кнопки -->
			<div class="top_btns_wrap">
				<div class="btn_light" @click="selectCategory('builds')" :class="{'btn_dark' : searchCategory == 'builds'}">Заведения</div><div class="btn_light" @click="selectCategory('doctors')" :class="{'btn_dark' : searchCategory == 'doctors'}">Врачи</div>
			</div>

			<div class="news"><p>Недавние посещения</p></div>

			<!-- Блок-контент медцентра -->
			<div class="med_center_wrap" v-show="searchCategory == 'builds'" v-for='item in clinicResult'>
				<div class="med_top_wrap">
					<div class="med_top_box1">
						<div class="med_center_avatar med_pic1 cover"></div>
						<p class="med_center_descr">Медицинский центр</p>
						<h3 class="med_center_name">{{item.name}}</h3>
						<p class="med_center_descr">{{item.address}}</p>
					</div>
					<div class="med_top_box2">
						<a class="med_btn_record shadow" @click="showClinic(item._id)">Запись</a>
					</div>
				</div>
				<div class="med_bottom_wrap">
					<p class="line_activ">Направление деятельности:</p>

					<!-- Список направлений деятельности -->
					<ul class="line_activ_list">
						<li>нефлоголия</li>
						<li>травматология</li>
						<li>лаборатория</li>
						<li>неврология</li>
					</ul>

					<!-- Кнопка показать больше -->
					<a class="show_more">Показать больше</a>
				</div>
			</div>

			<!-- Блок-контент медцентра -->
			<div class="med_center_wrap" v-show="searchCategory == 'doctors'" v-for='item in doctorResult'>
				<div class="med_top_wrap">
					<div class="med_top_box1" @click="showDoctor(item._id)">
						<div class="med_center_avatar med_pic1 cover"></div>
						<div class="med_center_title">Доктор высшей категории</div>
						<h3 class="med_center_name">{{item.last_name}} {{item.first_name}}</h3>
					</div>
					<div class="med_top_box2">
						<a class="med_btn_record shadow" @click="showAgenda(item._id)">Запись</a>
					</div>
				</div>
				<div class="med_bottom_wrap">
					<p class="line_activ">Специализации:</p>

					<!-- Список направлений деятельности -->
					<ul class="line_activ_list">
						<li v-for="spec in item.specialization">{{spec}}</li>
					</ul>

					<!-- Кнопка показать больше -->
					<a class="show_more">Показать больше</a>
				</div>
			</div>

			<div class="changer_width"></div>

			<!-- Блок под высоту нижнего меню -->
			<div class="help_block"></div>
			<!-- Нижнее меню -->
			<sm-phone-footer></sm-phone-footer>
		</div>
		<div class="right_window column"> </div>
	</section>
</template>
<script>
	export default {
		name: 'search',
		mounted: function () {
			this.$store.commit('TITLE', 'Поиск')
			this.$store.commit('FIRST', {
				show: true,
				icon: 'arrow.svg',
				go:'patient_page',
				iconClass: 'arrow'
			})
			this.$store.commit('SECOND', {
				show: false
			})

			this.$parent.dashClases = ['doctor-cabinet']

			if(this.$parent.searchWord)
				this.search(this.$parent.searchWord)
		},
		data() {
			return {
				searchCategory: this.$parent.searchCategory,
				clinicResult: [],
				doctorResult: [],
				searchWord: ''
			}
		},
		methods: {
			search (text) {
				if(text.length < 3)
					return false

				this.$parent.searchWord = text
				this.$api.post('search/global', {
					search: text,
					per_page: 15,
					current_page: 1
				}).then((response)=>{
					this.clinicResult = response.clinic.data
					this.doctorResult = response.user.data
				})
			},
			selectCategory (category) {
				this.$parent.searchCategory = this.searchCategory = category
			},
			showAgenda(id) {
				this.$router.push({path: 'agenda', query: {id: id}})
			},
			showDoctor(id) {
				this.$router.push({path: 'profile', query: {id: id}})
			},
			showClinic(id) {
				this.$router.push({name: 'Clinic', query: {id: id}})
			}
		}
	}
</script>

<style scoped>
	.btn_dark {
		background-color: #565656 !important;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// Search.vue?347c736d